declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID as string | undefined;
const analyticsEnabled = import.meta.env.VITE_ENABLE_ANALYTICS === 'true' && Boolean(measurementId);

export function isAnalyticsEnabled() {
  return analyticsEnabled;
}

export function getGaMeasurementId() {
  return measurementId;
}

export function trackEvent(eventName: string, params: Record<string, unknown> = {}) {
  if (!analyticsEnabled || typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', eventName, params);
}

export function trackPageView(path: string, title?: string) {
  trackEvent('page_view', {
    page_path: path,
    page_title: title,
  });
}

export function trackCtaClick(label: string, location: string) {
  trackEvent('cta_click', {
    cta_label: label,
    cta_location: location,
  });
}

export function trackFormSubmit(formName: string, status: 'success' | 'error') {
  trackEvent('form_submit', {
    form_name: formName,
    form_status: status,
  });
}

export function trackSearchQuery(query: string, source: string) {
  trackEvent('search', {
    search_term: query,
    search_source: source,
  });
}
